console.log('SKU script loaded');

document.addEventListener('change', function () {
  setTimeout(() => {
    const variantContainer = document.querySelector('[data-product-variants]');
    const skuElement = document.querySelector('#hasta-product-sku span');
    const variantIdInput = document.querySelector('input[name="id"]');

    if (!variantContainer || !skuElement || !variantIdInput) return;

    try {
      const variants = JSON.parse(variantContainer.textContent);
      const variantId = Number(variantIdInput.value);

      console.log('Current variant id:', variantId);

      const variant = variants.find(v => Number(v.id) === variantId);

      console.log('Found variant:', variant);

      if (variant) {
        skuElement.textContent = variant.sku || '';
      }
    } catch (e) {
      console.error('SKU update failed', e);
    }
  }, 300);
});